/* eslint-disable */
module.exports = {
  stk500v1: require('./stk500v1'),
  stk500v2: require('./stk500v2'),
  avr109: require('./avr109')
};
